import React from 'react'

function ResentInvitations({
        alreadySentEmailsList,
        handleRemoveResendEmail,
        handleCloseResendModal,
        handleResendEmails,
        isMailLoading,
        roleId,
        crssrImage,
        dletImage,
        ThreeDots, }) {
        return (
                <>
                        <div className="modal">
                                <div className="modal-close-invite outter-modal-main">
                                        <a
                                                className=""
                                                onClick={handleCloseResendModal}
                                                disabled={isMailLoading}
                                        >
                                                <img src={crssrImage} alt="Edit Icon" />{" "}
                                        </a>
                                </div>
                                <div className="modal-invite-head">
                                        <h2 className="">Resend Invitations</h2>
                                </div>
                                {/* List the already sent emails here */}
                                <div>
                                        <div className="the-modal-inuser">
                                                <label htmlFor="grid-password" className="">
                                                        Email
                                                </label>
                                                {alreadySentEmailsList.map((email) => (
                                                        <div key={email.email} className="the-modal-inusers">
                                                                <div className="resend-invitation">
                                                                        <input
                                                                                type="email"
                                                                                className=""
                                                                                name="email"
                                                                                required
                                                                                placeholder="Enter Email ID"
                                                                                value={email.email}
                                                                                disabled
                                                                        />
                                                                        <label
                                                                                htmlFor="grid-password"
                                                                                className="type-of-acc"
                                                                        >
                                                                                Role
                                                                        </label>
                                                                        <select value={email.userType} disabled>
                                                                                <option value="">Select Role</option>
                                                                                {roleId.map((role) => (
                                                                                        <option key={role._id} value={role._id}>
                                                                                                {role.user_type}
                                                                                        </option>
                                                                                ))}
                                                                        </select>
                                                                        {alreadySentEmailsList.length > 1 && (
                                                                                <button
                                                                                        className="del-resend"
                                                                                        onClick={() => handleRemoveResendEmail(email)}
                                                                                >
                                                                                        <img src={dletImage} alt="delete-icon" />{" "}
                                                                                </button>
                                                                        )}
                                                                </div>
                                                        </div>
                                                ))}
                                        </div>
                                </div>
                                <div className="sprint-btn-outer resend-invoice">
                                        <button
                                                type="button"
                                                onClick={handleCloseResendModal}
                                                disabled={isMailLoading}
                                                className="submit-client cancel-sprint"
                                        >
                                                Cancel
                                        </button>
                                        <button
                                                type="button"
                                                className="submit-client save-sprint"
                                                disabled={isMailLoading}
                                                onClick={handleResendEmails}
                                        >
                                                {isMailLoading ? (
                                                        <div className="outter-load-table">
                                                                <ThreeDots
                                                                        height="18"
                                                                        width="20"
                                                                        radius="9"
                                                                        color="white"
                                                                        ariaLabel="three-dots-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClassName=""
                                                                        visible={true}
                                                                />
                                                        </div>
                                                ) : (
                                                        "Resend Invitations"
                                                )}
                                        </button>
                                </div>
                        </div>
                </>
        )
}

export default ResentInvitations